import { useTranslation } from 'react-i18next';
import SucessIcon from '../../assets/CircleSuccess.svg';
import './Success.scss';

interface Props {
  rtl: boolean;
}

function Success({ rtl }: Props) {
  const { t } = useTranslation();

  return (
    <div className={rtl ? 'success__container success_arabic' : 'success__container'}>
      <div className='row'>
        <img className='success--icon' src={SucessIcon} alt='success' />
        <div className='success--title thankYou'>{t("ThankYou")}</div>
        <div className='success--title orderSuccess'>{t("OrderSuccess")}</div>

        <div className='success__orderDetails--container'>
          <div className='success--orderNumbers'>
            <div className='order__Label sansFont'>{t("OrderNumberIs")}</div>
            <div className='order__ticketNumber'>{window.localStorage.getItem("codId")}</div>
          </div>
          <div className='sucess--orderConfirmation'>
            <div className='order__Label sansFont'>{t("ConfirmationSent")}</div>
            <div className='order__ticketNumber'>{window.localStorage.getItem("emailID")}</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Success;